import { render, staticRenderFns } from "./MatchItem.vue?vue&type=template&id=400115ac&"
import script from "./MatchItem.vue?vue&type=script&lang=js&"
export * from "./MatchItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports